var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center justify-content-center text-center p-20"},[_c('div',[_c('div',{staticClass:"mb-3 mt-n5"},[_c('span',{staticClass:"svg-icon svg-icon-10x svg-icon-danger"},[_c('inline-svg',{attrs:{"src":"media/svg/icons/General/Sad.svg"}})],1)]),_c('h5',[_vm._v("Belum ada member check in saat ini")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }